import { Card, CardHeader, Typography, CardContent, Divider, ListItem, Avatar, ListItemText, Pagination, Box, Link } from "@mui/material";
import { chunk } from "lodash";
import { useShowContext } from "ra-core";
import { ChangeEvent, FC, useCallback, useEffect, useState } from "react";
import { RecPatch } from "@/dataProvider/tools";
import { AlertAndTime, DeploymentDashboardResponseDto } from "@/gen/api/deploy";
import { AlertIcon, AlertList, displayAlert, NoAlerts } from "../dashboard/alertCard";
import { useUserTimeFormat } from "@/utils/userTimeFormat";
import { Link as RouteLink } from 'react-router-dom'
import { genUrlWithHashid } from "@/utils/hashid";


const pageSize = 3;

const DeploymentAlertsCard: FC = () => {
  const { record } = useShowContext<DeploymentDashboardResponseDto & RecPatch>()
  const alertCount = (record 
    ? (record.deploymentAlerts?.length || 0)
    : 0)

  const [page, setPage] = useState(1) // 1 based page location
  const [alertChunks, setAlertChunks] = useState<AlertAndTime[][]>([])
  useEffect(() => {
    setPage(1)
    const alertList = 
      record 
      ? (record.deploymentAlerts || []).sort((a, b) => (b.alertTime || '') > (a.alertTime || '') ? -1 : 1) 
      : []
    setAlertChunks(chunk(alertList, pageSize))
  }, [JSON.stringify(record), setPage, setAlertChunks])

  const handleChange = useCallback((e: ChangeEvent<any>, value: number) => {
    setPage(value)
  }, [setPage])

  const format = useUserTimeFormat()
  return (
    <Card>
      <CardHeader
        title={(
          <Typography
            color="textPrimary"
            variant="h6"
          >
            Alerts
          </Typography>
        )}
      />
      <CardContent sx={{ pt: 0 }} >
        <Divider />
        {alertCount > 0 ?
          <AlertList>
            {alertChunks[page - 1]?.map((a, i) => (
              <ListItem key={a.deploymentId + '' + i} divider>
                <Link 
                  underline="none"
                  component={RouteLink}
                  to={genUrlWithHashid('/deployments/list/$0/show', a.deploymentId || 0)}
                >
                  <AlertIcon {...a} />
                  <ListItemText
                    disableTypography
                    primary={(
                      <Typography
                        className={a.isWarning ? 'warning' : 'error'}
                        variant="body2"
                      >
                        {displayAlert(a)}
                      </Typography>
                    )}
                    secondary={(
                      <Typography
                        className={a.isWarning ? 'warning' : 'error'}
                        variant="caption"
                      >
                        {a.alertTime && format(a.alertTime, 'PPp')}
                      </Typography>
                    )}
                  />
                </Link>
              </ListItem>))
            }
          </AlertList> :
          <NoAlerts />
        }
        {alertChunks.length > 1 &&
          <Pagination 
            count={Math.ceil(alertCount / pageSize)} 
            page={page}
            defaultPage={1}
            sx={{ mb: -2 }} 
            onChange={handleChange} 
          />        
        }
      </CardContent>
    </Card>
  )
}

export default DeploymentAlertsCard;

